{
  "title": "Lös in kod",
  "label": "Ange din värdekod",
  "placeholder": "t.ex. SPECIAL-PROMO",
  "button": "Lös in åtkomst",
  "info": "Om du har en värdekod från en kampanj eller evenemang, ange den ovan för att låsa upp premiumåtkomst.",
  "success_title": "Lyckades",
  "success_message": "Värdekoden löstes in!",
  "error_empty": "Vänligen ange en värdekod.",
  "error_invalid_code": "Den här värdekoden är inte giltig. Kontrollera koden och försök igen.",
  "error_expired_code": "Den här värdekoden har gått ut och kan inte längre användas.",
  "error_already_redeemed": "Den här värdekoden har redan lösts in.",
  "error_network": "Kunde inte nå servern. Kontrollera din anslutning och försök igen.",
  "error_unknown": "Något gick fel vid inlösen av din kod. Försök igen senare."
}
